export class Protocols {
    public static readonly protocolTypes = [
        { "id": 0, "name": "None"},
        { "id": 1, "name": "HTTP"},
        { "id": 2, "name": "AMQP"},
        { "id": 3, "name": "MQTT"}
    ];
}